import { TextField, InputAdornment, Autocomplete } from '@mui/material';
import { Search } from '@mui/icons-material';

export default function SearchFilterSort({
    filterOptions,
    onSearchInputChange = () => {},
    onFilterChange = () => {}
}) {
    return (
        <div className="my-event-list-sort-search-filter-container">
            <div className="my-event-list-search-container">
                <TextField
                    placeholder="Search your events..."
                    fullWidth
                    slotProps={{ input: { startAdornment: <SearchIcon /> } }}
                    onChange={(e) => onSearchInputChange(e.target.value)}
                    // sx={{
                    //     '& .MuiOutlinedInput-input': {
                    //         padding: '12px 14px',
                    //         paddingLeft: '0px',
                    //     }
                    // }}
                />
            </div>

            <div className="my-event-list-sort-filter-container">
                <Autocomplete
                    options={filterOptions}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, newValue) => onFilterChange(newValue?.value || 'all')}
                    renderInput={(params) => <TextField {...params} label="Filter By" fullWidth />}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            minWidth: '150px'
                        }
                    }}
                />
                {/* <Autocomplete
                    options={['Sort by Start Date', 'Sort by Creation Date']}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Sort By"
                            fullWidth
                        />
                    )}
                /> */}
            </div>
        </div>
    );
}

function SearchIcon() {
    return (
        <InputAdornment position="start">
            <Search sx={{ color: 'var(--quaternary-color)' }} />
        </InputAdornment>
    );
}
